import React from 'react';
import SocialLink from '../components/SocialLink';

import './Footer.scss';

function Footer({ ...props }) {
  return (
    <footer {...props}>
      <div className="d-none d-md-block">
        <div className="container-lg py-5">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <div className="dp me-2">
                <span>Dickson</span>&nbsp;<span>Palomeras</span>
              </div>
              <p className="text-gray m-0">&copy; 2021. All Rights Reserved</p>
            </div>
            <SocialLink childClassName="mx-3" />
          </div>
        </div>
      </div>
      <div className="d-block d-md-none">
        <div className="container-lg pt-4 pb-3">
          <div className="d-flex justify-content-center">
            <div className="mb-4">
              <SocialLink childClassName="mx-3" />
            </div>
          </div>
          <div className="text-center">
            <small className="text-gray m-0">
              Dickson Palomeras &copy; 2021. All Rights Reserved
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default React.memo(Footer, (prev, next) => true);
